import React from 'react';
import bappy from"../../Assests/Images/Background Remove CAE (10).png"
import rakib from"../../Assests//Images/Rakib.png"
import ceo from"../../Assests//Images/ceo.png"
import asmaul from '../../Assests/Images/Asmaul.png'
import aliul from '../../Assests/Images/Aliul.png'

const Meet = () => {
     return (
          <div>
               {/* <!-- component --> */}
<div class="bg-indigo-300">
    <div class=" mx-auto px-6 py-16">
    <div class="mx-auto sm:w-12/12 lg:w-8/12 ">
        <div>
        <h1 class="md:text-4xl text-3xl font-bold">Crazy Team</h1>
        <p class="mt-2 text-gray-900 font-medium">Meet Our Crazy Team!</p>
        </div>

        <div class="mt-4">
        <div 
         data-aos="fade-down" data-aos-duration='1000'
        class="relative flex flex-col justify-end overflow-hidden rounded-b-xl pt-6">
            <div class="group   relative flex cursor-pointer justify-between rounded-xl bg-amber-200 before:absolute before:inset-y-0 before:right-0 before:w-1/2 before:rounded-r-xl before:bg-gradient-to-r before:from-transparent before:to-amber-600 before:opacity-0 before:transition before:duration-500 hover:before:opacity-100">
            <div class="relative  space-y-1 p-4">
                <h4 class="text-xl text-amber-900">Muhammad Bappy</h4>
                <div class="relative h-6 text-amber-800 text-sm">
                <span class="transition duration-300 group-hover:invisible group-hover:opacity-0">Web Developer</span>
                <a href="https://mbappy.netlify.app/" target='_blank' class="flex items-center gap-3 invisible absolute left-0 top-0 translate-y-3 transition duration-300 group-hover:visible group-hover:translate-y-0">
                    <span>Visit More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 -translate-x-4 transition duration-300 group-hover:translate-x-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </a>
                </div>
            </div>
            <img class="absolute bottom-0 right-4 w-[5.6rem] transition duration-300 group-hover:scale-[1.4]" src={bappy} alt="" />
            </div>
        </div>
        <div 
         data-aos="fade-down" data-aos-duration='1000'
        class="relative -mr-6 flex flex-col justify-end overflow-hidden rounded-b-xl pt-6 pr-6">
            <div class="group relative flex cursor-pointer justify-between rounded-xl bg-orange-200 before:absolute before:inset-y-0 before:right-0 before:w-1/2 before:rounded-r-xl before:bg-gradient-to-r before:from-transparent before:to-orange-600 before:opacity-0 before:transition before:duration-500 hover:before:opacity-100">
            <div class="relative space-y-1 p-4">
                <h4 class="text-xl text-orange-900">Shomik Uzzaman</h4>
                <div class="relative h-6 text-orange-800 text-sm">
                <span class="transition duration-300 group-hover:invisible group-hover:opacity-0">CEO</span>
                <a href="https://www.facebook.com/crazyhridoyy" target='_blank ' class="w-max flex items-center gap-3 invisible absolute left-0 top-0 translate-y-3 transition duration-300 group-hover:visible group-hover:translate-y-0">
                    <span>Visit More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 -translate-x-4 transition duration-300 group-hover:translate-x-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </a>
                </div>
            </div>
            <img class="absolute -bottom-1 -right-2 w-[8rem] transition duration-300 group-hover:scale-[1.4]" src={ceo} alt="" />
            </div>
        </div>
        <div 
         data-aos="fade-down" data-aos-duration='1000'
        class="relative flex flex-col justify-end overflow-hidden rounded-b-xl pt-6">
            <div class="group relative flex cursor-pointer justify-between rounded-xl bg-rose-200 before:absolute before:inset-y-0 before:right-0 before:w-1/2 before:rounded-r-xl before:bg-gradient-to-r before:from-transparent before:to-rose-600 before:opacity-0 before:transition before:duration-500 hover:before:opacity-100">
            <div class="relative space-y-1 p-4">
                <h4 class="text-xl text-rose-900">Rakib Ahmed</h4>
                <div class="relative h-6 text-rose-800 text-sm">
                <span class="transition duration-300 group-hover:invisible group-hover:opacity-0">Co-Founder</span>
                <a href="https://instagram.com/_talk_a_tive_" target='_blank ' class="w-max flex items-center gap-3 invisible absolute left-0 top-0 translate-y-3 transition duration-300 group-hover:visible group-hover:translate-y-0">
                    <span>Visit More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 -translate-x-4 transition duration-300 group-hover:translate-x-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </a>
                </div>
            </div>
            <img class="absolute bottom-0 -right-2 w-[7rem] transition duration-300 group-hover:scale-[1.4]" src={rakib} alt="" />
            </div>
        </div>
        <div 
         data-aos="fade-down" data-aos-duration='1000'
        class="relative -mr-6 flex flex-col justify-end overflow-hidden rounded-b-xl pt-6 pr-6">
            <div class="group relative flex cursor-pointer justify-between rounded-xl bg-fuchsia-200 before:absolute before:inset-y-0 before:right-0 before:w-1/2 before:rounded-r-xl before:bg-gradient-to-r before:from-transparent before:to-fuchsia-600 before:opacity-0 before:transition before:duration-500 hover:before:opacity-100">
            <div class="relative w-7/12 space-y-1 p-4">
                <h4 class="text-xl text-fuchsia-900">Asmaul Hoque</h4>
                <div class="relative h-6 text-fuchsia-800 text-sm">
                <span class="transition duration-300 group-hover:invisible group-hover:opacity-0">Editor</span>
                <a href="https://www.facebook.com/asmaul.hoque01?mibextid=ZbWKwL" target='_blank ' class="w-max flex items-center gap-3 invisible absolute left-0 top-0 translate-y-3 transition duration-300 group-hover:visible group-hover:translate-y-0">
                    <span>Visit More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 -translate-x-4 transition duration-300 group-hover:translate-x-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </a>
                </div>
            </div>
            <img class="absolute -bottom-1 right-2 w-[5.5rem] transition duration-300 group-hover:scale-[1.4]" src={asmaul} alt="" />
            </div>
        </div>
        <div  
         data-aos="fade-down" data-aos-duration='1000'
        class="relative flex flex-col justify-end overflow-hidden rounded-b-xl pt-6">
            <div class="group relative flex cursor-pointer justify-between rounded-xl bg-blue-200 before:absolute before:inset-y-0 before:right-0 before:w-1/2 before:rounded-r-xl before:bg-gradient-to-r before:from-transparent before:to-blue-600 before:opacity-0 before:transition before:duration-500 hover:before:opacity-100">
            <div class="relative space-y-1 p-4">
                <h4 class="text-xl text-blue-900">Aliul Islam</h4>
                <div class="relative h-6 text-blue-800 text-sm">
                <span class="transition duration-300 group-hover:invisible group-hover:opacity-0">Manager</span>
                <a href="https://www.facebook.com/aliulislam082" target='_blank ' class="w-max flex items-center gap-3 invisible absolute left-0 top-0 translate-y-3 transition duration-300 group-hover:visible group-hover:translate-y-0">
                    <span>Visit More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 -translate-x-4 transition duration-300 group-hover:translate-x-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </a>
                </div>
            </div>
            <img class="absolute bottom-0 right-2 w-[5.7rem] transition duration-300 group-hover:scale-[1.4]" src={aliul} alt="" />
            </div>
        </div>
        </div>
    </div>
    </div>
</div>
          </div>
     );
};

export default Meet;